import { render } from "./CompanyPlaceOrder.vue?vue&type=template&id=0dcc58bd&scoped=true"
import script from "./CompanyPlaceOrder.vue?vue&type=script&lang=js"
export * from "./CompanyPlaceOrder.vue?vue&type=script&lang=js"

import "./CompanyPlaceOrder.vue?vue&type=style&index=0&id=0dcc58bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcc58bd"]])

export default __exports__